import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CredentialVerification, ICredentialVerification } from './../../../shared/models/products/credential-verification';
import { Address, IAddress } from './../../../shared/models/address';

import { GlobalValidators } from './../../../../shared/validators/global-validators';

import { UserService } from './../../../../shared/services/user.service';
import { PurchaseService } from './../../../shared/services/purchase.service';
import { ViewStateService } from './../../../../shared/services/view-state.service';
import { PurchaseStateService } from './../../../shared/services/purchase-state.service';
import { NotificationsService } from './../../../../shared/services/notifications.service';

@Component({
  selector: 'app-email',
  templateUrl: './email.component.html'
})
export class EmailComponent implements OnInit {
  emailForm: FormGroup;
  personId: string;
  address: IAddress;
  product: ICredentialVerification;
	manualValidForm=true;
	//emailFormat = '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$';
	//emailFormat = "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$";

  constructor(private formBuilder: FormBuilder, private viewState: ViewStateService, private router: Router,
    private notifications: NotificationsService, private purchaseService: PurchaseStateService,
	private purchaseState: PurchaseStateService,
	private userService: UserService) { }

  ngOnInit() {
    this.product = <CredentialVerification>this.purchaseState.getTempProductData();
    this.buildForm();
    this.viewState.stopLoading();
  }

  isExpired(): boolean {
    if(this.userService.CurrentUser.hasExpiredCredentials && !this.userService.CurrentUser.credentialHolder) {
      return true;
    }
    return false;
  }

  isValidEmail() {
    return true
  }

  onSubmit(updateFormValue) {
		this.formValues = updateFormValue;
		this.validateForm();
		if(this.emailForm.valid && this.isValidEmail()) {
      
			this.product.sendTo.email = this.formValues.email;
			this.purchaseState.patchProducts(this.product);

			this.router.navigate(["purchase/checkout"]);
		}
  }

  onBack(event: Event) {
    event.preventDefault();

    this.router.navigate([this.purchaseService.previousRouteUrl])
  }

	private buildForm(): void {
		this.emailForm = this.formBuilder.group({
			'email': [this.formValues.email, [
				Validators.required,
        Validators.maxLength(150),
        Validators.email
			]
			]
    });
    
	}

	private validateForm() {
		for(const control in this.emailForm.controls)
		{
			this.emailForm.controls[control].updateValueAndValidity();
		}

		let hasErrors = false;
		for (const field in this.formErrors) {
			this.formErrors[field] = '';
			const control = this.emailForm.get(field);
			if (control && control.invalid) {
				hasErrors = true;
				const messages = this.validationMessages[field];
				for (const key in control.errors) {
					this.formErrors[field] += messages[key] + ' ';
				}
			}
		}
		if (hasErrors){
			this.notifications.error("Fields Invalid", "Please review the form and resubmit.");
			this.viewState.stopLoading();
		}
	}

	private formValues = {
			'email': ''
	};

	formErrors = {
			'email': ''			
	};

	validationMessages = {
	    'email': {
	      'required': 'Email required.',
        'maxlength': 'Email max length 150 characters.',
				'email':'Valid Email Required',
				'pattern': 'Valid Email Required'
	    }
	};

}
